import produce from "immer";
import { BusinessPolicyCoverageExclusionsActions } from ".";
import { IStoreState } from "../../initialStoreState";
import { defaultBusinessPolicyCoverageExclusionsState } from "./businessPolicyCoverageExclusions.types";
import {
  CLEAR_BUSINESS_POLICY_COVERAGE_EXCLUSION,
  CLEAR_BUSINESS_POLICY_COVERAGE_EXCLUSION_STATE,
  FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSION_FAILED,
  FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSION_PROGRESS,
  FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSION_SUCCESS,
  FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSIONS_LIST_FAILED,
  FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSIONS_LIST_PROGRESS,
  FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSIONS_LIST_SUCCESS,
} from "./businessPolicyCoverageExclusionsActions";
import { LoadState } from "../../../constants/enums";

export const businessPolicyCoverageExclusionsReducer = (
  state: IStoreState["business"]["coverageExclusions"] = defaultBusinessPolicyCoverageExclusionsState,
  action: BusinessPolicyCoverageExclusionsActions
) => {
  switch (action.type) {
    case FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSIONS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.data = [];
      });
      return newState;
    }
    case FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSIONS_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }
    case FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSIONS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.data = [];
      });
      return newState;
    }

    case FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.coverageExclusionLoading = LoadState.InProgress;
        draftState.coverageExclusion =
          defaultBusinessPolicyCoverageExclusionsState["coverageExclusion"];
      });
      return newState;
    }
    case FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSION_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.coverageExclusionLoading = LoadState.Loaded;
        draftState.coverageExclusion = data;
      });
      return newState;
    }
    case FETCH_BUSINESS_POLICY_COVERAGE_EXCLUSION_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.coverageExclusionLoading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case CLEAR_BUSINESS_POLICY_COVERAGE_EXCLUSION: {
      const newState = produce(state, (draftState) => {
        draftState.coverageExclusion =
          defaultBusinessPolicyCoverageExclusionsState["coverageExclusion"];
      });
      return newState;
    }
    case CLEAR_BUSINESS_POLICY_COVERAGE_EXCLUSION_STATE: {
      return defaultBusinessPolicyCoverageExclusionsState;
    }
    default: {
      return state;
    }
  }
};
